const appGlobalScript = appGlobalScriptNs.default || (() => {});
import * as appGlobalScriptNs from '/home/runner/_work/dc.ncj.customer-experience-npm/dc.ncj.customer-experience-npm/src/global/app.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
